function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M396.991 2042.5l-3.308 3.025a.537.537 0 000 .808c.244.223.64.223.884 0l3.75-3.429a.537.537 0 000-.808l-3.75-3.429a.667.667 0 00-.884 0 .537.537 0 000 .808l3.308 3.025z",
  id: "select_arrow_svg__a"
}));
var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  transform: "matrix(0 1 1 0 -2038.5 -393.5)",
  xlinkHref: "#select_arrow_svg__a"
});
function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5
  }, props), _ref, _ref2);
}
export default SvgSelectArrow;